import AnalyticsDashboardMockup from '@/components/marketing/technology/AnalyticsDashboardMockup'
import TechnologyDetailPage from '@/components/marketing/technology/TechnologyDetailPage'
import type { TechnologyDetailProps } from '@/types/technology'

/* The technology section — royalty analytics, in full.
 *
 * A child of /technology/platform. This is the CONSOLE view — the studio ships
 * a simpler analytics screen for individual artists, and the mock says so.
 */
export default function Analytics(props: TechnologyDetailProps) {
  return <TechnologyDetailPage {...props} visual={<AnalyticsDashboardMockup />} />
}
